import { registerChatGPTShellElement } from "./ChatGPTShellElement"

registerChatGPTShellElement()
